// src/components/LoginForm.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode'; // Asegúrate de tener instalada esta dependencia
import '../assets/styles/LoginForm.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const LoginForm = () => {
  const [cedula, setCedula] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
 
    try {
      // Realizar solicitud al backend para autenticar el usuario
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
      const response = await axios.post(`${API_URL}/login`, {
        identificador: cedula,
        password,
      });

      // Verificación del token recibido
      const token = response.data.token;
      if (!token) {
        throw new Error('Token no recibido');
      }

      // Decodificar el token para obtener información del usuario
      const decodedToken = jwtDecode(token);

      const userRole = decodedToken.role;
      const userName = `${decodedToken.nombre} ${decodedToken.apellido}`;

      // Almacenar el token según la preferencia del usuario
      if (rememberMe) {
        localStorage.setItem('token', token);
        localStorage.setItem('userName', userName);
        localStorage.setItem('role', userRole);
        localStorage.setItem('user', JSON.stringify({ name: userName, role: userRole }));
      } else {
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('userName', userName);
        sessionStorage.setItem('role', userRole);
        sessionStorage.setItem('user', JSON.stringify({ name: userName, role: userRole }));
      }

      // Redirigir al usuario según su rol
      if (userRole === 'Admin') {
        navigate('/dashboard');
      } else if (userRole === 'Gestor') {
        navigate('/database'); // Gestor va directo a la vista de Registros
      } else if (userRole === 'Supervisor') {
        navigate('/supervisor');
      } else if (userRole === 'Lider') {
        navigate('/database');
      } else {
        navigate('/no-autorizado');
      }
    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      alert('Credenciales incorrectas o error en el servidor');
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <div className="login-header">
          <img 
            src="/operamich.png" 
            alt="Operamich Logo" 
            className="login-logo"
          />
          <h1 className="login-title">OPERAMICH</h1>
        </div>
        <h2>Iniciar Sesión</h2>
        <input
          type="text"
          placeholder="Cédula"
          value={cedula}
          onChange={(e) => setCedula(e.target.value)}
          required
        />
 
        <div className="password-container">
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <span className="password-toggle-icon" onClick={() => setShowPassword(!showPassword)}>
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <div className="remember-me-container">
          <input
            type="checkbox"
            id="rememberMe"
            checked={rememberMe}
            onChange={() => setRememberMe(!rememberMe)}
          />
          <label htmlFor="rememberMe">Mantener sesión activa</label>
        </div>

        <button type="submit">Iniciar Sesión</button>
      </form>
    </div>
  );
};

export default LoginForm;
